import { render, staticRenderFns } from "./VRadioSwitcher.vue?vue&type=template&id=149dff78&scoped=true"
import script from "./VRadioSwitcher.vue?vue&type=script&lang=js"
export * from "./VRadioSwitcher.vue?vue&type=script&lang=js"
import style0 from "./VRadioSwitcher.vue?vue&type=style&index=0&id=149dff78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149dff78",
  null
  
)

export default component.exports